module.exports = {
  siteUrl: process.env.GATSBY_SITE_URL, // Site domain. Do not include a trailing slash!

  siteTitleMeta: `Affio Online Will Writing Service`, // This allows an alternative site title for meta data for pages.
  siteDescriptionMeta: `Affio is an online Will writing service for the UK. Our simple online service allows you to make a fully legal Will without a solicitor in less than an hour. It’s free to get started!`, // This allows an alternative site description for meta data for pages.

  shareImageWidth: 1000, // Change to the width of your default share image
  shareImageHeight: 523, // Change to the height of your default share image

  shortTitle: `Affio`, // Used for App manifest e.g. Mobile Home Screen
  siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
  backgroundColor: `#e9e9e9`, // Used for Offline Manifest
  themeColor: `#15171A`, // Used for Offline Manifest
}
